// src/fontawesome.js

import { library } from '@fortawesome/fontawesome-svg-core';
import { 
  faEdit, faTimes, faBell, faCheckCircle, faFilter, faEyeSlash, faClock, 
  faExclamationTriangle, faPauseCircle, faRedo, faSpinner, faTimesCircle, faArrowRight,
  // Menu icons
  faTachometerAlt, faFileInvoice, faPlus, faUsers, faBoxes, faSignOutAlt, faCheck, 
  faUser, faHeadset, faInfo, faFile, faLayerGroup, faNetworkWired, faEye, faCogs,
  faProjectDiagram, faFlask, faShoppingCart, faUserCheck, faChartBar, faChartLine, faServer,
  faLock, faDatabase, faEnvelope, faHistory, faShieldAlt, faGlobe, faCodeBranch,
  faUserShield, faClipboardList, faBullhorn, faSitemap, faDownload, faTasks
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

library.add(
  faEdit, faTimes, faBell, faCheckCircle, faFilter, faEyeSlash, faClock, 
  faExclamationTriangle, faPauseCircle, faRedo, faSpinner, faTimesCircle, faArrowRight,
  // Menu icons
  faTachometerAlt, faFileInvoice, faPlus, faUsers, faBoxes, faSignOutAlt, faCheck, 
  faUser, faHeadset, faInfo, faFile, faLayerGroup, faNetworkWired, faEye, faCogs,
  faProjectDiagram, faFlask, faShoppingCart, faUserCheck, faChartBar, faChartLine, faServer,
  faLock, faDatabase, faEnvelope, faHistory, faShieldAlt, faGlobe, faCodeBranch,
  faUserShield, faClipboardList, faBullhorn, faSitemap, faDownload, faTasks
);

export { FontAwesomeIcon };
